//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import {
  IGetTikTokUserResponse,
  ITikTokUser,
} from '@apis/tiktok-user/tiktokUserApiModel';
import { deserializeUser } from '@apis/tiktok-user/tiktokUserApiUtils';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { Serialized } from '@utils/types/Serialized';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const TIKTOK_DEFAULT_ENDPOINT = '/api/v1';

const tiktokGatewayUserFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'tiktok_gateway',
    `${TIKTOK_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
};

/**
 * Gets the client's connected TikTok account
 *
 * GET /api/v1/user
 */
export const getTikTokUser = async (): Promise<ITikTokUser> => {
  const res = await tiktokGatewayUserFetch(`/user`);

  return (
    await res.json<IGetTikTokUserResponse>((res) => ({
      data: deserializeUser(res.data),
    }))
  ).data;
};
